// extracted by mini-css-extract-plugin
export default {"mainView":"Login_mainView__JY6v6"};